import React, { useState, useEffect } from 'react'
import { Radio } from 'antd'
import { Ul, Li, Dropdown } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import DatePicker from 'meinian-package/src/component/datePicker'
import { SelectDisplay, } from 'meinian-package/src/baseComponent/select'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import Filter from '.'
import { PriceZoneRange } from './priceZone/priceZoneRange'
import { CollectDate } from './date'
import { StyleType } from './styleType'
import './more.less'

export default (props) => {
  const { onChange, ...otherProps } = props
  const [visible, setVisible] = useState(false)
  const onOk = (val) => {
    onChange && onChange(val)
    setVisible(false)
  }
  const onClear = () => {
    onChange && onChange({
      createdTimeStart: undefined,
      createdTimeEnd: undefined,
      season: null,
      bloggerTags: null,
      element: null,
      cityList: null,
      marketName: null,
      city: null,
      selfCollectStatus: null,
      blogTimeStart: undefined,
      blogTimeEnd: undefined,
      upStyleFlag: undefined,
      // materialsFlag: 1,
      annotationFlag: undefined,
      styleType: undefined,
      markUserList: undefined,
      annotationUserList: undefined,
      tagIdList: undefined,
      priceStart: undefined,
      priceEnd: undefined,
      clothFlag: undefined,
      submitTimeStart: undefined,
      submitTimeEnd: undefined,
    })
    setVisible(false)
  }
  return <Dropdown
    placement="bottomLeft"
    overlay={<More {...otherProps} onOk={onOk} onClear={onClear} visible={visible} />}
    trigger="click"
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
  >
    <span><SelectDisplay value={null} visible={visible} placeholder="更多筛选" /></span>
  </Dropdown>
}

const More = (props) => {
  const { onOk, onClear, value = {}, visible,
    inspirationId, hiddenAnnotate, hiddenDate, hiddenSample, hiddenPriceZoneRange, hiddenExamineUser } = props
  const [params, setParams] = useState(value)
  useEffect(() => {
    setParams(value)
  }, [visible, JSON.stringify(value)])
  return <div>
    {/* 打开更多筛选的时候 重新加载 保证数据最新 */}
    <Ul className="meinian-select-more" style={{ width: 480 }}>
      {!hiddenDate ? <CollectDate params={params} setParams={setParams} /> : null}
      {params.gender && params.platformId ? <Season params={params} setParams={setParams} /> : null}
      {params.platformId ? <>
        <Area params={params} setParams={setParams} />
        <Runway params={params} setParams={setParams} />
        <Market params={params} setParams={setParams} />
        <City params={params} setParams={setParams} />
        <Upload params={params} setParams={setParams} />
      </> : null}
      <PublishTime params={params} setParams={setParams} />
      <SubmissionTime params={params} setParams={setParams} />
      {/* {!hiddenUpdateStyle ? <UpdateStyle params={params} setParams={setParams} /> : null} */}
      {!hiddenSample && <Sample params={params} setParams={setParams} />}
      {!hiddenAnnotate ? <Annotate params={params} setParams={setParams} /> : null}
      <StyleType params={params} setParams={setParams} />
      {!hiddenPriceZoneRange && <PriceZoneRange params={params} setParams={setParams} />}
      <Tag params={params} setParams={setParams} inspirationId={inspirationId} requiredTag={props.requiredTag} hiddenNoTag={props.hiddenNoTag} />
      {!hiddenExamineUser && <ExamineUser params={params} setParams={setParams} inspirationId={inspirationId} />}
      <AnnotateUser params={params} setParams={setParams} inspirationId={inspirationId} />
    </Ul>
    <div className="meinian-select-action-btn">
      <Button type="normal" style={{ marginRight: 16 }} onClick={onClear}>清空</Button>
      <Button type="primary" onClick={() => onOk(params)}>确认</Button>
    </div>
  </div>
}

const Season = ({ params, setParams }) => {
  if (Number(params.platformId) === PLATFORM_VALUE.UPLOAD || Number(params.platformId) === PLATFORM_VALUE.DY) return null
  return <Li className="item">
    <span className="label">季度</span>
    <Filter.Season
      value={params.season}
      onChange={season => setParams(pre => ({ ...pre, season }))}
      gender={params.gender}
      platformId={params.platformId}
    />
  </Li>
}
const Area = ({ params, setParams }) => {
  if (Number(params.platformId) !== PLATFORM_VALUE.INS) return null
  return <Li className="item">
    <span className="label">地区</span>
    <Filter.AreaIns
      value={params.bloggerTags}
      onChange={bloggerTags => setParams(pre => ({ ...pre, bloggerTags }))}
    />
  </Li>
}
const Runway = ({ params, setParams }) => {
  if (Number(params.platformId) !== PLATFORM_VALUE.SHOW) return null
  return <Li className="item">
    <span className="label">秀场</span>
    <Filter.Runway
      value={params.cityList}
      onChange={cityList => setParams(pre => ({ ...pre, cityList }))}
      gender={params.gender}
    />
  </Li>
}
const Market = ({ params, setParams }) => {
  if (Number(params.platformId) !== PLATFORM_VALUE.WHOLESALE) return null
  return <Li className="item">
    <span className="label">市场</span>
    <Filter.WholesaleMarket
      value={params.marketName}
      onChange={marketName => setParams(pre => ({ ...pre, marketName }))}
    />
  </Li>
}
const City = ({ params, setParams }) => {
  if (Number(params.platformId) !== PLATFORM_VALUE.RETAIL) return null
  return <Li className="item">
    <span className="label">地区</span>
    <Filter.RetailCity
      value={params.city}
      onChange={city => setParams(pre => ({ ...pre, city }))}
    />
  </Li>
}
const Upload = ({ params, setParams }) => {
  if (Number(params.platformId) !== PLATFORM_VALUE.UPLOAD) return null
  return <Li className="item">
    <span className="label">来源</span>
    <Filter.UploadType
      value={params.selfCollectStatus}
      onChange={selfCollectStatus => setParams(pre => ({ ...pre, selfCollectStatus }))}
    />
  </Li>
}

const SubmissionTime = ({ params, setParams }) => { // 提交审核时间
  return <Li className="item">
    <span className="label">提交审核时间</span>
    <DatePicker
      startTime={params.submitTimeStart}
      endTime={params.submitTimeEnd}
      noneText="不限"
      onChange={([submitTimeStart, submitTimeEnd]) => {
        setParams(pre => ({ ...pre, submitTimeStart, submitTimeEnd }))
      }}
    />
  </Li>
}

const PublishTime = ({ params, setParams }) => { // 发布时间
  return <Li className="item">
    <span className="label">发布/上架时间</span><DatePicker
      style={{ maxWidth: '120px' }}
      startTime={params.blogTimeStart}
      endTime={params.blogTimeEnd}
      noneText="不限"
      onChange={([blogTimeStart, blogTimeEnd]) => setParams(pre => ({ ...pre, blogTimeStart, blogTimeEnd }))}
    />
  </Li>
}

const Sample = ({ params, setParams }) => {
  return <Li className="item">
    <span className="label">是否生成过样衣</span>
    <Radio.Group className="radio-group" onChange={e => setParams(pre => ({ ...pre, clothFlag: e.target.value }))} value={params.clothFlag}>
      <Radio className="radio" value={undefined}>不限</Radio>
      <Radio className="radio" value={1}>是</Radio>
      <Radio className="radio" value={0}>否</Radio>
    </Radio.Group>
  </Li>
}

const Annotate = ({ params, setParams }) => {
  return <Li className="item">
    <span className="label">已批注款式</span>
    <Radio.Group className="radio-group" onChange={e => setParams(pre => ({ ...pre, annotationFlag: e.target.value }))} value={params.annotationFlag}>
      <Radio className="radio" value={undefined}>不限</Radio>
      <Radio className="radio" value={1}>已批注</Radio>
      <Radio className="radio" value={0}>未批注</Radio>
    </Radio.Group>
  </Li>
}

const ExamineUser = ({ params, setParams, inspirationId }) => {
  return <Li className="item">
    <span className="label">审核成员</span>
    <Filter.ExamineUser
      value={params.markUserList?.map(m => Number(m))}
      onChange={markUserList => setParams(pre => ({ ...pre, markUserList }))}
      inspirationId={inspirationId}
      placeholder="不限"
      ulStyle={{ maxHeight: 140 }}
    />
  </Li>
}

const AnnotateUser = ({ params, setParams, inspirationId }) => {
  return <Li className="item">
    <span className="label">批注成员</span>
    <Filter.User
      value={params.annotationUserList}
      onChange={annotationUserList => setParams(pre => ({ ...pre, annotationUserList }))}
      inspirationId={inspirationId}
      placeholder="不限"
      ulStyle={{ maxHeight: 140 }}
    />
  </Li>
}
const Tag = ({ params, setParams, inspirationId, requiredTag, hiddenNoTag }) => {
  return <Li className="item">
    <span className="label">标签</span>
    <Filter.Tag
      value={params.tagIdList}
      onChange={(tagIdList, anyMatchFlag) => setParams(pre => ({ ...pre, tagIdList, anyMatchFlag }))}
      inspirationId={inspirationId}
      params={params}
      requiredTag={requiredTag}
      hiddenNoTag={hiddenNoTag}
      placeholder="不限"
    />
  </Li>
}
